module.exports = __webpack_public_path__ + "img/matht.23f108b5.png";